var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationTrainStation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-train-station",
    transform: "translate(-702 -2249)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(702 2249)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-train",
    "data-name": "Icon ionic-ios-train",
    transform: "translate(706.286 2251.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M14.226,29.926l-1.111-1.406a.261.261,0,0,0-.44.012.5.5,0,0,0,.009.58l.136.173H9.51l.136-.173a.5.5,0,0,0,.009-.58.261.261,0,0,0-.44-.012L8.1,29.926a.5.5,0,0,0-.009.58.262.262,0,0,0,.44.012l.327-.413h4.605l.327.413a.262.262,0,0,0,.44-.012A.5.5,0,0,0,14.226,29.926Z",
    transform: "translate(-7.952 -20.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_229",
    "data-name": "Groupe 229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M12.9,2.587h-.379a.349.349,0,0,0-.357-.337H10.018a.349.349,0,0,0-.357.337H9.326A1.4,1.4,0,0,0,7.875,3.915V8.888c0,.744,3.214,1.37,3.214,1.37S14.3,9.632,14.3,8.888V3.915A1.355,1.355,0,0,0,12.9,2.587ZM11.089,8.993a1.013,1.013,0,1,1,1.071-1.012A1.043,1.043,0,0,1,11.089,8.993Zm2.143-3.372a.349.349,0,0,1-.357.337H9.3a.349.349,0,0,1-.357-.337V4.273A.349.349,0,0,1,9.3,3.936h3.571a.349.349,0,0,1,.357.337Z",
    transform: "translate(-7.875 -2.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M17.643,20.124a.894.894,0,1,1-.894-.894A.894.894,0,0,1,17.643,20.124Z",
    transform: "translate(-13.535 -14.521)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTrainStation);
export default __webpack_public_path__ + "static/media/location-train-station.fdfbd32ccc41cb4ad461fb97ffe62f3f.svg";
export { ForwardRef as ReactComponent };